import React from 'react';

const Footer = (props) => {
    return (
        <footer />
    );

}

export { Footer }